var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.48,36.67h-1.28v-1.9c0-7.84-6.36-14.2-14.2-14.2s-14.2,6.36-14.2,14.2v1.9h-1.28c-6.29,0-11.39,5.1-11.39,11.39v19.98c0,6.29,5.1,11.39,11.39,11.39h30.96c6.29,0,11.39-5.1,11.39-11.39v-19.98c0-6.29-5.1-11.39-11.39-11.39ZM43.4,34.77c0-3.65,2.96-6.6,6.6-6.6h0c3.65,0,6.6,2.96,6.6,6.6v1.9h-13.21v-1.9ZM69.28,68.04c0,2.1-1.7,3.8-3.8,3.8h-30.96c-2.1,0-3.8-1.7-3.8-3.8v-19.98c0-2.1,1.7-3.8,3.8-3.8h30.96c2.1,0,3.8,1.7,3.8,3.8v19.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeLock);
export default __webpack_public_path__ + "static/media/acae_lock.69b1a99c.svg";
export { ForwardRef as ReactComponent };